<div class="dialog-header">
  <div class="header-title">
		<span style="font-size: 120%;">
			#{{cartNumber}} {{trayNumber}} - Change Cabinet
		</span>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>


<!--<div class="cabinets-parts-block">-->
<div class="edit-block">
  <form #userEditForm="ngForm">
    <div class="form-block">
      <div class="form-row">
        <p-listbox [options]="cabs" [(ngModel)]="selectedCabs" autocomplete="off" [filter]="true" [multiple]="true"
                   [checkbox]="true"
                   filterMode="startsWith" [filterValue]="searchString" [optionLabel]="'showName'"
                   [ngModelOptions]="{standalone: true}" class="p-list-box-block">
          <p-header>
            Search Cabinet
          </p-header>
        </p-listbox>
      </div>
    </div>

    <div class="save-btn-block">
      <div class="side-block">

      </div>
      <button mat-button class="save-btn" (click)="save()"
              [disabled]="!selectedCabs?.length || loadingSpinner || emptyLoadingSpinner"
              tabindex="1" type="submit"
              [ngClass]="{'disabled-button': !selectedCabs?.length || loadingSpinner || emptyLoadingSpinner}">
        <span *ngIf="!loadingSpinner">Change</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>

      <div class="side-block">
        <button mat-button class="empty-btn" (click)="empty()"
                [disabled]="loadingSpinner || emptyLoadingSpinner"
                tabindex="1" type="submit"
                [ngClass]="{'disabled-button': loadingSpinner || emptyLoadingSpinner}">
          <span *ngIf="!emptyLoadingSpinner">Empty</span>
          <lib-mini-progress-spinner *ngIf="emptyLoadingSpinner"></lib-mini-progress-spinner>
        </button>
      </div>
    </div>
  </form>

</div>
<div class="parts-block">
  <div class="parts-label">
		<span style="font-size: 120%;">
      Parts:
		</span>
  </div>
  <div class="parts-body">
    <div class="parts-line-item" *ngFor="let part of parts">
      <span class="part-count">
        #{{part.cabinetNumber}} |
      </span>
      <span class="part-count">
        {{part.cnt}}
      </span>
      x
      <span class="part-count">
        {{part.description}}
		  </span>
      <span class="part-count" *ngIf="part.widthFraction && part.lengthFraction">
      -
        {{part.widthFraction}} x
        {{part.lengthFraction}}
		  </span>
    </div>

  </div>
</div>
<!--</div>-->
